<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditLeave
			:leaveId="leave_id"
			:color="'#FFB946'"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditLeave from "@/views/leave/leave_edit.vue";

export default {
	name: 'EditleaveDialog',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: false,
			error_msg: '',

			leave_id: 0,
		}
	},
	components: {
		EditLeave
	},
	created() {
		this.leave_id = Number(this.$route.params.evid);
	},
	methods: {
		onClose() {
			window.open("/close")
		}
	}
}
</script>


